'use client';

import { CSSProperties } from 'react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

export { toast } from 'sonner';

/**
 * A toaster component for displaying notifications, based on Sonner.
 */
export function Toaster({ ...props }: ToasterProps) {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as CSSProperties
      }
      theme={theme as ToasterProps['theme']}
      {...props}
    />
  );
}
